var _a;
import { pxToRem } from '../utils/utils';
import { breakpoints } from './breakpoints';
var paymentIconRatio = (40 / 24);
export var icons = {
    tailIconHeight: '18px',
    tailIconWidth: '32px',
    paymentIconRatio: paymentIconRatio,
    iconSizesMap: {
        small: pxToRem('16px'),
        medium: pxToRem('24px'),
        large: pxToRem('32px'),
        xlarge: pxToRem('48px'),
        xxlarge: pxToRem('64px')
    },
    iconsPaymentMap: (_a = {},
        _a[breakpoints.mobile] = [
            pxToRem('24px'),
            pxToRem((24 * paymentIconRatio) + 'px')
        ],
        _a[breakpoints.tablet] = [
            pxToRem('28px'),
            pxToRem((28 * paymentIconRatio) + 'px')
        ],
        _a[breakpoints.desktop] = [
            pxToRem('32px'),
            pxToRem((32 * paymentIconRatio) + 'px')
        ],
        _a),
    tailsMap: {
        '3k': ['jq', '3k'],
        '9w': ['9w'],
        'a3': ['a3'],
        'aa': ['ax', 'yx', 'mq', 'oh', 'pt', 'cp', 'yv', 'aa'],
        'ab': ['ab'],
        'af': ['a5', 'wx', 'wh', 'fb', 'af'],
        'ai': ['ai'],
        'as': ['as', 'qx'],
        'ay': ['ay', 'n7'],
        'az': ['az'],
        'b6': ['b6'],
        'ba': ['t3', 'lv', 'pv', 'zt', 'cj', 'ba', 're', 'a0'],
        'br': ['br'],
        'ca': ['ca'],
        'ci': ['ci'],
        'cx': ['cx'],
        'cz': ['cz'],
        'dx': ['r6', 'dx'],
        'ei': ['ei'],
        'fi': ['fi'],
        'fj': ['fj'],
        'ga': ['ga'],
        'gl': ['gl'],
        'hu': ['hu', 'hx'],
        'ib': ['pm', 'i2', 'ib', 'yw', '5m'],
        'ig': ['ig'],
        'jl': ['xm', 'jl'],
        'jp': ['jp', 'v3'],
        'ju': ['ju'],
        'ka': ['ka'],
        'ke': ['ke'],
        'kl': ['kl'],
        'km': ['km'],
        'la': ['jj', 'xl', 'la', '4m', 'lu', 'lp', '4c', 'pz'],
        'lg': ['lg'],
        'lo': ['lo'],
        'mh': ['mh'],
        'mi': ['mi'],
        'mu': ['mu'],
        'ok': ['ok'],
        'ou': ['ou'],
        'oz': ['oz'],
        'pg': ['pg'],
        'pr': ['pr'],
        'ps': ['ps'],
        'qf': ['qf'],
        'qr': ['qr'],
        'rj': ['rj'],
        'f7': ['f7'],
        'sb': ['sb'],
        'sq': ['sq'],
        'su': ['fv', 'su'],
        'tf': ['tf'],
        'tp': ['tp'],
        'tk': ['tk'],
        'tn': ['tn'],
        'uk': ['uk'],
        'ul': ['ul'],
        'vn': ['vn'],
        'wf': ['wf'],
        'lx': ['lx'],
        'lh': ['lh'],
        'sk': ['sk'],
        'bt': ['bt'],
        'os': ['os'],
        'sn': ['sn'],
        'ho': ['ho'],
        'nt': ['nt'],
        'nz': ['nz'],
        'lm': ['lm'],
        'tg': ['tg'],
        'ek': ['ek'],
        'wy': ['wy'],
        'et': ['et'],
        'sv': ['sv'],
        'at': ['at'],
        '6i': ['6i'],
        'oo': ['oo'],
    }
};
